export default __webpack_public_path__ + "static/media/DragOver.1dc2533c.svg";